import store from "../../../core/store";

export const listPublicSpecificationDeliveries = (stage_id) => {
    return store.dispatch({
        action: "table.public_specification_deliveries/LIST_PUBLIC_SPECIFICATION_DELIVERIES",
        method: "GET",
        endpoint: "/stages/" + stage_id + "/specification_deliveries",
        main: true
    });
};